var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mounting-portal",
    { attrs: { "mount-to": "#order-widget-target" } },
    [
      _c("div", { staticClass: "layout-landingpage__bundles" }, [
        _c("h2", [_vm._v("Bestseller")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bundles" },
          [
            _vm.orderWidget == undefined
              ? _vm._l(3, function (index) {
                  return _c(
                    "div",
                    { key: "mock-" + index },
                    [
                      _c(
                        "order-widget-box",
                        { attrs: { "widget-item": _vm.mockWidget } },
                        [
                          _c("loading-animation", {
                            attrs: {
                              "loading-title": _vm.$t(
                                "landingpage:orderwidget.loading.title"
                              ),
                              "display-type": "blocking",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                })
              : _vm._l(_vm.orderWidget, function (widget, key) {
                  return _c(
                    "div",
                    { key: key },
                    [
                      _c("order-widget-box", {
                        attrs: { "widget-index": key, "widget-item": widget },
                      }),
                    ],
                    1
                  )
                }),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "bundle bundle--create",
                  staticStyle: { cursor: "pointer" },
                  attrs: { tabindex: "-1" },
                  on: { click: _vm.onCustomOrderWidgetClick },
                },
                [
                  _c("div", { staticClass: "bundle__wrapper" }, [
                    _c("span", { staticClass: "bundle__slots" }, [
                      _vm._v(
                        _vm._s(_vm.$t("landingpage:orderwidget.custom.title"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "button bundle__button",
                      attrs: { href: _vm.orderUrl },
                      on: { click: _vm.orderTracking },
                    },
                    [_vm._v(_vm._s(_vm.$t("general:non_special_texts.order")))]
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }